import { Theme, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
